var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "closed_eye",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Elipse_31",
  "data-name": "Elipse 31",
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#eee9ff"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_300",
  "data-name": "Grupo 300",
  transform: "translate(4 4.003)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_481",
  "data-name": "Caminho 481",
  d: "M8.991,13.256a.544.544,0,0,1-.389-.161A3.178,3.178,0,1,1,13.1,8.6a.549.549,0,0,1,0,.778L9.38,13.1a.544.544,0,0,1-.389.161Zm1.857-4.485a2.078,2.078,0,0,0-1.806,3.105l2.833-2.833a2.067,2.067,0,0,0-1.027-.272Z",
  transform: "translate(-2.959 -2.959)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_482",
  "data-name": "Caminho 482",
  d: "M4.5,14.38a.559.559,0,0,1-.36-.132A10.654,10.654,0,0,1,2.048,11.8a4.447,4.447,0,0,1,0-4.4C3.84,4.595,6.445,2.98,9.2,2.98a7.645,7.645,0,0,1,4.6,1.608.551.551,0,1,1-.661.881A6.532,6.532,0,0,0,9.2,4.081c-2.371,0-4.639,1.424-6.225,3.913a3.336,3.336,0,0,0,0,3.215,10.078,10.078,0,0,0,1.879,2.2.555.555,0,0,1,.059.778A.533.533,0,0,1,4.5,14.38Z",
  transform: "translate(-1.309 -1.712)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_483",
  "data-name": "Caminho 483",
  d: "M10.846,17.339A7.248,7.248,0,0,1,8,16.752a.549.549,0,0,1,.426-1.013,6.161,6.161,0,0,0,2.415.5c2.371,0,4.639-1.424,6.225-3.913a3.336,3.336,0,0,0,0-3.215,10.456,10.456,0,0,0-.741-1.028A.558.558,0,0,1,16.4,7.3a.551.551,0,0,1,.778.081A11.666,11.666,0,0,1,18,8.516a4.447,4.447,0,0,1,0,4.4C16.2,15.725,13.6,17.339,10.846,17.339Z",
  transform: "translate(-2.957 -2.829)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_484",
  "data-name": "Caminho 484",
  d: "M12.49,15.124a.556.556,0,0,1-.543-.448.54.54,0,0,1,.44-.639,2.07,2.07,0,0,0,1.63-1.63.553.553,0,0,1,1.086.206,3.154,3.154,0,0,1-2.51,2.51A.481.481,0,0,0,12.49,15.124Z",
  transform: "translate(-4.094 -4.1)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_485",
  "data-name": "Caminho 485",
  d: "M1.8,20.365a.544.544,0,0,1-.389-.161.554.554,0,0,1,0-.778L6.9,13.942a.55.55,0,0,1,.778.778L2.19,20.2A.544.544,0,0,1,1.8,20.365Z",
  transform: "translate(-1.252 -4.585)",
  fill: "#db56e0"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_486",
  "data-name": "Caminho 486",
  d: "M14.331,7.835a.545.545,0,0,1-.389-.161.554.554,0,0,1,0-.778l5.483-5.483a.55.55,0,1,1,.778.778L14.72,7.674a.545.545,0,0,1-.389.161Z",
  transform: "translate(-4.585 -1.252)",
  fill: "#db56e0"
}))));
export default __webpack_public_path__ + "static/media/closed_eye.c06b6f89.svg";
export { SvgComponent as ReactComponent };